<template>
<!-- 品牌管理 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form class="findform">
        <el-form-item label="品牌名称：" style="display:flex;width:35%">
          <el-input :title="name" v-model="name" placeholder="请输入品牌名称 (20字以内)" maxlength="20" style="width:90%;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">品牌管理</p>
      <el-button type="danger" @click="addOrEditBrand()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </section>
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column label="序号" align="center">
          <template scope="scope">
            <span :title="scope.row.Id" :label="scope.row.Id">{{scope.row.Id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌名称" align="center">
          <template scope="scope">
            <span :title="scope.row.Name" :label="scope.row.Name">{{scope.row.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template scope="scope">
            <span :title="scope.row.CTime" :label="scope.row.CTime">{{scope.row.CTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作记录" align="center">
          <template scope="scope">
            <span @click="endViews(scope)" class="action_container">查看操作记录</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200" align="center">
          <template scope="scope">
            <span @click="addOrEditBrand(scope.row)" class="action_container">
              <i class="el-icon-edit-outline"></i>编辑
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="dialogTable" :before-close="cancelForm" :show-close= false>
    <template v-slot:title>
      <ul class="drawer_title">
        <li>{{record}}</li>
        <el-button type="danger" @click="cancelForm">关 闭</el-button>
      </ul>
    </template>
    <div class="drawer_div">
      <el-table ref="table" :data="gridData" height="600">
        <el-table-column property="OperationDes" label="操作类型" align="center"/>
        <el-table-column property="OperatorName" label="操作人" align="center"/>
        <el-table-column property="CTime" label="操作时间" align="center"/>
        <template slot="append">
          <div class="scrollingTips">
            <p v-if="loading">正在加载</p>
            <p v-if="noMore">没有更多了</p>
          </div>
        </template>
      </el-table>
    </div>
  </el-drawer>
  
  <!-- 新增/编辑品牌管理-弹框 -->
  <el-dialog title="品牌管理" :center="true" class="add_order_cancle" width="30%" :visible.sync="isToExamine">
    <el-form>
      <el-form-item label="品牌名称:" label-width="80px">
        <el-input maxlength="20" v-model="brandName" placeholder="请输入品牌名称 (20字以内)" style="width:80%"/>
      </el-form-item>
      <el-form-item label="品牌Logo:" label-width="80px">
        <el-upload class="avatar-uploader" action accept=".png, .jpg" :show-file-list="false"
          :before-upload="beforeAvatarUpload" style="height: 80px;">
          <img v-if="Thumbnail" :src="Thumbnail" style="width:80px;height:80px" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
        <div style="color: #888;">
          <img src="../../assets/img/aicon15_09.jpg"/> 尺寸必须为90px*36px，支持png、jpg格式
        </div>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <el-button type="button" @click="isToExamine = false"
        class="el-button el-button--default cancle normal_btn">取消</el-button>
      <el-button type="button" @click="editSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { UploadImgForServer } from '../../api/newOss';
import { getSelectAllBrand, getSelectBaseDataOpeationLog, getInsertBrand,
  getUpdateBrandById, getSelectBrandInfoById } from "../../api/api";
  
  function getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg
    return dataURL;
  }

  function main(src, cb) {
    var image = new Image();
    image.src = src + "?v=" + Math.random(); // 处理缓存
    image.crossOrigin = "*"; // 支持跨域图片
    image.onload = function() {
      var base64 = getBase64Image(image);
      cb && cb(base64);
    };
  }
export default {
  mixins: [alertTrends],
  data() {
    return {
      bId: "",
      dataId: "",
      show3: true, // 查询区域默认展开
      isToExamine: false, // 品牌管理弹框
      brandName: "", // 品牌名称,
      Thumbnail: "", // 品牌Logo
      dialogTable: false, // 抽屉详情
      timer: null,
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      record: "操作记录", // 操作记录
      goodsPageIndex: 1, // 详情页页码
      goodsPageSize: 50, // 详情页条数 默认50条
      gridData: [],
      loading: false, // 是否加载中
      noMore: false, // 是否最后一页, 没有更多了
      name: "", // 品牌名称
    }
  },
  methods: {
      // 重置
    fnReset() {
      this.name = '';
      this.pageIndex = 1;
      this.getDataAnalysis();
    },

    //查询列表
    getDataAnalysis() {
      let addParams = {
        operId: localStorage.Id, // 当前操作人id
        name: this.name, // 品牌名称
        pageIndex: this.pageIndex,// 分页数据 当前页码
        pageSize: this.pageSize // 分页数据 每页显示条数
      };
      getSelectAllBrand(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 点击查看操作记录
    endViews(scope) {
      this.record = "操作记录";
      this.dataId = scope.row.Id;
      this.goodsPageIndex = 1;
      this.dialogTable = true;
      this.browseNumber() // 加载数据, 默认先加载50条
      // 监听表格dom对象的滚动事件
      this.$nextTick(() => {
        let dom = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
        dom.addEventListener('scroll', () => {
          let { scrollHeight, scrollTop, clientHeight } = dom
          const scrollDistance = scrollHeight - scrollTop - clientHeight
          if (scrollDistance <= 0 && this.loading !== true) {
            // 等于0证明已经到底，可以再次请求接口
            this.browseNumber() // 加载数据
          }
        })
      })
    },
    // 操作记录+无限滚动
    browseNumber() {
      var that = this;
      if (that.goodsPageIndex < that.goodsPageSize) {
        let addParams = {
          baseDataId: that.dataId,
          baseDataType: 1,
          pageIndex: that.goodsPageIndex, // 当前页码
          pageSize: that.goodsPageSize // 条数，默认50条
        };
        getSelectBaseDataOpeationLog(addParams).then(data => {
          if (data.ResultCode == 1) {
            that.gridData = that.gridData.concat(data.ResultObj)
            that.goodsPageIndex++
            that.loading = false
          } else {
            that.noMore = true
            that.loading = false
          }
        })
      } else {
        that.noMore = true
        that.loading = false
      }
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.gridData = [];
      this.dialogTable = false;
      clearTimeout(this.timer);
    },
    // 触发 编辑按钮 & 新增按钮 是否回显
    addOrEditBrand(row) {
      // 如果有数据就是编辑 否则就是新增
      if (row) {
        this.bId = row.Id;
        var loginParams = {
          brandId: this.bId // 品牌ID
        };
        getSelectBrandInfoById(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.brandName = data.Name; // 品牌名称
            this.Thumbnail = data.ImgUrl.replace(localStorage.BaseUrl, ''); // 品牌Logo
            main(data.ImgUrl, function(base64) {
              this.Thumbnail = base64; // 品牌Logo
            });
          }
        })
      } else {
        this.bId = "";
        this.brandName = ""; // 品牌名称
        this.Thumbnail = ""; // 品牌Logo
      }
      this.isToExamine = true; // 品牌管理详情弹框展示
    },
    // 保存按钮
    editSubmit() {
      if(this.brandName == ""){
        this.showAlert('请输入品牌名称');
        return false
      }else if(this.Thumbnail == ""){
        this.showAlert('请上传品牌Logo');
        return false
      }
      // 判断是编辑还是新增
      if (this.bId) {
        var loginParams = {
          operatorId: localStorage.Id, // 当前操作人id
          brandId: this.bId, // 当前修改的品牌ID
          brandName: this.brandName, // 品牌名称
          imgUrl: this.Thumbnail // 品牌Logo
        };
        getUpdateBrandById(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('品牌保存成功', 'success');
            this.isToExamine = false;
            this.getDataAnalysis();
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        var loginParams = {
          operatorId: localStorage.Id, // 当前操作人id
          brandName: this.brandName, // 品牌名称
          imgUrl: this.Thumbnail // 品牌Logo
        };
        getInsertBrand(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('品牌保存成功', 'success');
            this.isToExamine = false;
            this.getDataAnalysis();
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
    },
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 90;
        let height = 36;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          that.Thumbnail = e.target.result
          var obj = {
            base64Img:  e.target.result,
          };
          UploadImgForServer(obj).then(data => {
            if (data.ResultCode == 1) {
              that.Thumbnail = localStorage.BaseUrl+data.ResultObj
            }
          });
        };
      },() => {
        this.showAlert('上传图片宽高尺寸应为90*36');
      });
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.getDataAnalysis();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDataAnalysis();
    }
  },
  created() {
    let that = this;
    // 查询列表
    setTimeout(function() {
      that.getDataAnalysis();
    }, 200);
  }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 0px;
  margin-top: 0px;
}
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.scrollingTips {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// brandManagement.vue?5f2569cd